module.exports = __webpack_public_path__ + "static/media/t1.a63a3432.png";